"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const map_1 = __importDefault(require("lodash/map"));
/**
 * Returns formatted features array
 * @returns {Array}
 */
const getFeatures = (features, language) => {
    return (0, map_1.default)(features, (feature) => {
        return {
            icon: (0, get_1.default)(feature, 'icon', ''),
            id: (0, get_1.default)(feature, 'id'),
            name: (0, get_1.default)(feature, `name.en`, ''),
            primary: (0, get_1.default)(feature, 'primary', false),
            value: (0, get_1.default)(feature, `value.${language}`, ''),
            valueId: (0, get_1.default)(feature, 'valueId'),
        };
    });
};
exports.default = getFeatures;
